import { FC } from "react";
import { useSelector } from "react-redux";
import Modal from "react-modal";
import React from "react";
import "./modal.less";
import { RootState } from "../../../app.store";
interface ModalProps {}
const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    transform: "translate(-50%, -50%)",
  },
  overlay: {
    backgroundColor: "rgb(21 20 20 / 75%)",
    zIndex: 99,
  },
};
Modal.setAppElement("#root");
export const ModalComponent: FC<ModalProps> = (props) => {
  const confirmModal = useSelector(
    (state: RootState) => state.globalValue.confirm
  );
  return (
    <React.Fragment>
      <Modal style={customStyles} isOpen={confirmModal?.isModal ?? false}>
        <div id="modal">
          <div className="mb-2 font-bold text-2xl">Alert</div>
          <div className="divider" />
          <p className="py-4 text-lg">{confirmModal?.message}</p>
          <div className="flex-container ">
            <button onClick={confirmModal?.onClose} className="btn btn-default">
              Close
            </button>
            <button onClick={confirmModal?.onYes} className="btn btn-primary">
              Ok
            </button>
          </div>
        </div>
      </Modal>
    </React.Fragment>
  );
};
